function addElement (syntax, sentence, sentencePosition, key) {
  let startPosition = document.querySelector(key).selectionStart

  if (startPosition === 0 && sentencePosition === 0) {
    return { 'sentence': syntax + sentence, 'position': syntax.length }
  }

  let undefinedRegExp = /^undefined{1}/
  let array = Array.from(sentence)

  const position = sentencePosition === 0 ? startPosition : sentencePosition

  array[position - 1] += syntax
  sentencePosition = position + syntax.length

  array[position - 1] = array[position - 1].replace(undefinedRegExp, '')

  array = array.join('')
  return { 'sentence': array, 'position': sentencePosition }
}

export default { addElement }



// WEBPACK FOOTER //
// ./src/lib/AnswersMethods.js